import { render, staticRenderFns } from "./Agreements.vue?vue&type=template&id=54e192f1&scoped=true&"
import script from "./Agreements.vue?vue&type=script&lang=js&"
export * from "./Agreements.vue?vue&type=script&lang=js&"
import style0 from "./Agreements.vue?vue&type=style&index=0&id=54e192f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e192f1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/builds/evolvo/klientai.cramo.lt/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VStepper } from 'vuetify/lib'
import { VStepperContent } from 'vuetify/lib'
import { VStepperStep } from 'vuetify/lib'
installComponents(component, {VBtn,VProgressCircular,VStepper,VStepperContent,VStepperStep})
